const logoutFromAmeyo = () => {
  window.postMessage({ type: 'LOGOUT_FROM_AMEYO' }, '*');
};

export default logoutFromAmeyo;
